import React, { useEffect, useState } from 'react';

import { InputLabel, Select, Switch } from 'components/cosmos';
import { translate } from 'components/translate';
import { LOCALES } from 'configs/constants';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';

import ContentService from '../../ContentService';

const Language = ({
  className,
  t,
  onLanguageChange,
  onSignLanguageChange,
  language = '',
  signLanguage = false,
  isOnlineEventTemplate
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchLanguages = async () => {
      if (!isOnlineEventTemplate) {
        return;
      }

      const languages = await ContentService.fetchUserLanguages();

      languages &&
        setOptions(
          languages?.map(({ id, value }) => ({
            value: id,
            label: value
          }))
        );
    };

    fetchLanguages();
  }, [isOnlineEventTemplate]);

  if (!isOnlineEventTemplate) {
    return null;
  }

  const handleLanguageChange = (option) => {
    onLanguageChange?.(option?.value);

    if (option?.value !== LOCALES.PT_BR) {
      onSignLanguageChange?.(false);
    }
  };

  const handleSignLanguageChange = (event) => {
    onSignLanguageChange?.(event.target.checked);
  };

  return (
    <div className={className} data-test="container">
      <InputLabel htmlFor="language">{t('general.idiom')}</InputLabel>
      <p className="_text-gray-400">{t('language.description')}</p>
      <Select
        required
        name="language"
        id="language"
        placeholder={t('language.placeholder')}
        options={options}
        onChange={handleLanguageChange}
        value={language}
      />
      {LOCALES.PT_BR === language && (
        <Switch
          id="signLanguage"
          onChange={handleSignLanguageChange}
          isChecked={signLanguage}
        >
          {t('sign_language.description')}
        </Switch>
      )}
    </div>
  );
};

Language.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  language: PropTypes.string,
  signLanguage: PropTypes.bool,
  onLanguageChange: PropTypes.func,
  onSignLanguageChange: PropTypes.func,
  hasError: PropTypes.bool,
  isOnlineEventTemplate: PropTypes.bool
};

export default inject((stores) => ({
  isOnlineEventTemplate: stores.MembershipStore.isOnlineEventTemplate
}))(translate()(Language));
